import VTimePicker from './VTimePicker'

VTimePicker.install = function install (Vue) {
  Vue.component(VTimePicker.name, VTimePicker)
}

export default VTimePicker



// WEBPACK FOOTER //
// ./src/components/VTimePicker/index.js